import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute, Link, redirect, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import { Field, FormError, Input } from "@/components/ui/field";
import { AuthLayout } from "@/features/auth/auth-layout";
import { sessionQuery, useLogin } from "@/lib/api/queries";
import { applyApiError } from "@/lib/forms";

export const Route = createFileRoute("/login")({
  beforeLoad: async ({ context }) => {
    if (await context.queryClient.ensureQueryData(sessionQuery)) throw redirect({ to: "/" });
  },
  component: LoginPage,
});

const schema = z.object({
  username: z.string().trim().min(1, "Введите логин"),
  password: z.string().min(1, "Введите пароль"),
});
type Values = z.infer<typeof schema>;

function LoginPage() {
  const navigate = useNavigate();
  const login = useLogin();
  const [formError, setFormError] = useState<string>();
  const form = useForm<Values>({ resolver: zodResolver(schema) });
  const { errors } = form.formState;

  const submit = form.handleSubmit(async (values) => {
    setFormError(undefined);
    try {
      await login.mutateAsync(values);
      await navigate({ to: "/" });
    } catch (error) {
      setFormError(applyApiError(error, form.setError, []));
    }
  });

  return (
    <AuthLayout title="Вход">
      <form onSubmit={submit} className="grid gap-4" noValidate>
        <Field label="Логин" error={errors.username?.message}>
          {(control) => (
            <Input
              {...control}
              {...form.register("username")}
              autoComplete="username"
              autoCapitalize="none"
            />
          )}
        </Field>
        <Field label="Пароль" error={errors.password?.message}>
          {(control) => (
            <Input
              {...control}
              {...form.register("password")}
              type="password"
              autoComplete="current-password"
            />
          )}
        </Field>
        <FormError message={formError} />
        <Button type="submit" pending={login.isPending} className="mt-2">
          Войти
        </Button>
      </form>
      <p className="mt-8 text-sm text-muted">
        Есть приглашение?{" "}
        <Link to="/register" className="text-amber-text underline-offset-4 hover:underline">
          Зарегистрироваться
        </Link>
      </p>
    </AuthLayout>
  );
}
